import gql from 'graphql-tag'

export const NOTIFY_REMOVE_RECENTLY_VIEWED = gql`
  mutation NotifyRemoveRecentlyViewed($productErpIdentifier: String!, $removeAll: Boolean!) {
    notifyRemoveRecentlyViewed(productErpIdentifier: $productErpIdentifier, removeAll: $removeAll)
  }
`
